// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__lko5q","footerLinks":"Footer_footerLinks__iwRt9","copyright":"Footer_copyright__R+CUh","socialLinks":"Footer_socialLinks__sIB0L"};